import { LicenseType } from "@ews/react-data";
import { useMyProfileId } from "./Login/LoginProvider";
import { useSystemLicense } from "./ReactData/system";
import { useUserPermissions } from "./ReactData/user";
import { useCurrentSystemId } from "./Authorization";

export const useHasLicense = (licenseToTest: LicenseType, userId?: string) =>
{
    const me = useMyProfileId();
    const systemId = useCurrentSystemId();

    let userPermission = useUserPermissions(userId || me);

    const systemLicense = useSystemLicense(systemId || "");
    let { license } = systemLicense;

    if (userPermission.isReseller) {
        license = (systemLicense.license || LicenseType.NONE) | LicenseType.DETAIL_VIEW | LicenseType.OPERATE_AND_NOTIFICATION;
    }

    switch (licenseToTest) {
        case LicenseType.DETAIL_VIEW:
            break;
        case LicenseType.OPERATE_AND_NOTIFICATION:
            licenseToTest = LicenseType.DETAIL_VIEW | LicenseType.OPERATE_AND_NOTIFICATION;
            break;
        case LicenseType.PLAN_VIEW:
            licenseToTest = LicenseType.DETAIL_VIEW | LicenseType.OPERATE_AND_NOTIFICATION | LicenseType.PLAN_VIEW;
            break;
        case LicenseType.SMS:
            licenseToTest = LicenseType.DETAIL_VIEW | LicenseType.OPERATE_AND_NOTIFICATION | LicenseType.PLAN_VIEW | LicenseType.SMS;
            break;
    }
    return ((license || LicenseType.NONE) & licenseToTest) === licenseToTest;
};
